import { Message, Skeleton } from '@doveit/bricks';
import React, { FunctionComponent, ReactElement } from 'react';
import { useContactToProcessCount } from '../../hooks/use-contact-to-process-count/useContactToProcessCount';
import { CallContextType } from '../../../providers/api/dtos';

export const LOAD_ERROR_MESSAGE = 'Errore di caricamento';

export interface ViewContactToProcessCountProps {
  type: CallContextType,
  children: (count: number) => ReactElement,
}

const ViewContactToProcessCount: FunctionComponent<ViewContactToProcessCountProps> = ({
  type,
  children,
}) => {
  const {
    data: contactCount,
    isLoading: isContactCountLoading,
    error: contactCountError,
  } = useContactToProcessCount(type);

  if (contactCountError) {
    return (
      <Message
        type="critical"
        message={LOAD_ERROR_MESSAGE}
      />
    );
  }

  if (!contactCount || isContactCountLoading) {
    return <Skeleton aria-label="Conteggio in caricamento" />;
  }

  return children(contactCount.count);
};

export default ViewContactToProcessCount;
